import React, { memo } from 'react';
import { XCircleIcon } from 'lucide-react';
export function FailedApproaches() {
  const approaches = ['Los crucigramas genéricos son buenos, pero su cerebro ya se acostumbró a ellos y dejó de esforzarse.', 'Las aplicaciones de celular son frustrantes porque priorizan la tecnología sobre la conexión emocional.', 'Intentar memorizar listas a la fuerza no funciona porque no utiliza los "anclajes culturales" que usted ya posee.', 'Las vitaminas costosas prometen milagros pero no crean las nuevas conexiones neuronales que usted necesita.'];
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-50">
      <div className="max-w-3xl mx-auto" data-id="element-51">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-stone-900 mb-10 text-center" data-id="element-52">
          ¿Por qué lo que ha intentado no funciona?
        </h2>
        <ul className="space-y-6" data-id="element-53">
          {approaches.map((approach, index) => <li key={index} className="flex items-start" data-id="element-54">
              <XCircleIcon className="w-8 h-8 text-red-500 mr-4 flex-shrink-0 mt-1" data-id="element-55" />
              <span className="text-lg md:text-xl text-stone-700 leading-relaxed" data-id="element-56">
                {approach}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}